// extracted by mini-css-extract-plugin
export default {"previewInfo":"PreviewInfo_previewInfo__Cx13S","infoBadge":"PreviewInfo_infoBadge__IkBvu"};